export enum PowerBiReportType {
  Report = 'report',
  Dashboard = 'dashboard',
  Tile = 'tile',
  Visual = 'visual',
  Qna = 'qna',
}
